import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';

/**
 * Content traductions
 */
const fr = require('./languages/fr.json');
const es = require('./languages/es.json');
const en = require('./languages/en.json');
/**
 * Typology traductions
 */
const fr_typo = require('./typology/fr-typo.json');
const es_typo = require('./typology/es-typo.json');

/**
 * I18n configuration
 */
i18n
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    resources: {
      fr: {
        translations: fr,
        typology: fr_typo,
      },
      es: {
        translations: es,
        typology: es_typo,
      },
      en: {
        translations: en,
      },
    },
    fallbackLng: 'fr',
    debug: true,
    ns: ['translations', 'typology'],
    defaultNS: 'translations',
    keySeparator: '.',
    react: {
      wait: true,
    },
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/I18n/index.js